import { z } from 'zod';

export const roasterSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  isActive: z.boolean(),
  notes: z.string().optional(),
});

export type RoasterFormData = z.infer<typeof roasterSchema>;

export interface Roaster {
  id: string;
  name: string;
  isActive: boolean;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}
